/**
 * utils/devicePrefs.js
 * This computer's own name ("Siti - laptop kasir"), sent with every save to the shared online
 * books so "last saved by" means something while the app has no login (multi-device sync,
 * step 4). Stored per browser in its own localStorage key — deliberately outside storage.js's
 * versioned app data, same as sidebarPrefs.js: it describes THIS device, not the books.
 *
 * `asked` records that the one-time "name this computer" prompt has been answered, by naming
 * the computer OR by skipping it — skipping is a real, recorded choice (label stays ""), so the
 * prompt never nags again. The label can be changed any time in Pengaturan.
 * Superseded by the person's own name once login exists.
 */
export const DEVICE_LABEL_KEY = "bukukas2_device_label";
export const DEVICE_LABEL_MAX = 60;

export function loadDeviceLabel() {
  try {
    const raw = localStorage.getItem(DEVICE_LABEL_KEY);
    if (!raw) return { asked: false, label: "" };
    const v = JSON.parse(raw);
    return { asked: v && v.asked === true, label: typeof v?.label === "string" ? v.label : "" };
  } catch {
    return { asked: false, label: "" };
  }
}

/** Save a label (trimmed, capped) and mark the prompt as answered. `""` = skipped. */
export function saveDeviceLabel(label) {
  const clean = String(label || "").trim().slice(0, DEVICE_LABEL_MAX);
  try {
    localStorage.setItem(DEVICE_LABEL_KEY, JSON.stringify({ asked: true, label: clean }));
  } catch {
    // private mode / quota — the label is a convenience; never block the UI over it
  }
  return { asked: true, label: clean };
}
